import { render } from "./AddFAQ.vue?vue&type=template&id=591f9b6e&scoped=true"
import script from "./AddFAQ.vue?vue&type=script&lang=js"
export * from "./AddFAQ.vue?vue&type=script&lang=js"

import "./AddFAQ.vue?vue&type=style&index=0&id=591f9b6e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-591f9b6e"],['__file',"src/views/FAQManagement/components/contentComponents/AddFAQ.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "591f9b6e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('591f9b6e', __exports__)) {
    api.reload('591f9b6e', __exports__)
  }
  
  module.hot.accept("./AddFAQ.vue?vue&type=template&id=591f9b6e&scoped=true", () => {
    api.rerender('591f9b6e', render)
  })

}


export default __exports__